import AppLayout from '../../../../../component/appLayout';
import Button from '../../../../../component/button';
import { useHistory } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import Modal from '../../../../../component/modals/modal';
import DeleteModal from '../../../../../component/modals/deleteModal';
import {
  BottomContent,
  Content,
  Data,
  DataTitle,
  Header,
  HeaderText,
  LeftSide,
  LeftSideData,
  Logo,
  Main,
  RemoveButton,
  RepositoryData,
  Subheader,
  Text,
  Title
} from '../githubIntegration/styles';
import { REACT_APP_VERCEL_CLIENT_ID } from '../../../../../global/environment';
import { deleteVercelAccount, getVercelAccount } from '../../../../../services/vercelService';
import { getCompanySettingIntegration } from '../../../../../services/settingServices';
import { VercelAccountInterface } from '../../../../../interfaces/SettingsInterface';
import { rootStore } from '../../../../../mobx/rootStore';
import { BUTTON_TYPE, ICON_BUTTON_SIZE, ICON_BUTTON_TYPE } from '../../../../../global/constants';
import { Group, Container } from '../../../styles';
import IconButton from '../../../../../component/button/iconButton';
import { observer } from 'mobx-react-lite';
import Image from '../../../../../component/image';

function VercelIntegration() {
  //States
  const [vercelAccountList, setVercelAccountList] = useState([]);
  const [selectedModalId, setSelectedModalId] = useState<string | null>(null);

  // mobx states
  const { workspaceStore, settingStore } = rootStore;
  const { currentWorkspace } = workspaceStore || {};
  const { loading } = settingStore;

  //Other variable
  const history = useHistory();

  const loadData = useCallback(async () => {
    if (currentWorkspace?.id) {
      const response = await getVercelAccount();
      if (response) {
        setVercelAccountList(response);
      }
    }
  }, [currentWorkspace?.id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  // Handles navigation back to previous page
  const handleBackClick = useCallback(() => {
    history.goBack();
  }, [history]);

  //open delete model
  const handleOpenDeleteModal = useCallback((id: string) => {
    setSelectedModalId(id);
  }, []);

  //   close Delete Model
  const handleCloseDeleteModal = useCallback(() => {
    setSelectedModalId(null);
  }, []);

  const linkVercel = useCallback(() => {
    const array = new Uint8Array(16);
    crypto.getRandomValues(array);
    const state = Array.from(array, (byte) => byte.toString(16).padStart(2, '0')).join('');
    // eslint-disable-next-line max-len
    const link = `https://vercel.com/integrations/${REACT_APP_VERCEL_CLIENT_ID}/new?state=${state}&scope=team%20project%20deployment`;
    window.open(link, '_blank', 'noopener,noreferrer');
  }, []);

  const handleDeleteVercelAccount = useCallback(async () => {
    const response = await deleteVercelAccount(selectedModalId);
    if (response) {
      setSelectedModalId(null);
      await Promise.all([loadData(), getCompanySettingIntegration(currentWorkspace?.id)]);
    }
  }, [currentWorkspace?.id, loadData, selectedModalId]);

  return (
    <>
      <AppLayout>
        <Container className='desktop-content'>
          <Group>
            <Main>
              <Header>
                <IconButton
                  iconName='new-large-back-arrow-icon'
                  size={ICON_BUTTON_SIZE.SMALL}
                  variant={ICON_BUTTON_TYPE.TERTIARY}
                  onClick={handleBackClick}
                />
                <Title>Integrations</Title>
              </Header>
            </Main>
            <BottomContent>
              <Subheader>
                <LeftSide>
                  <Logo>
                    <Image imageKey='vercel_logo' alt='vercel-logo' width={42} height={42} />
                  </Logo>
                  <Content>
                    <Text>Vercel</Text>
                    <HeaderText>Deploy and track builds within tasks.</HeaderText>
                  </Content>
                </LeftSide>
                <Button variant={BUTTON_TYPE.PRIMARY} onClick={linkVercel} title='Link Vercel Account' />
              </Subheader>
              <RepositoryData>
                {vercelAccountList?.length > 0 &&
                  vercelAccountList?.map((item: VercelAccountInterface) => {
                    return (
                      <Data key={item?.id}>
                        <LeftSideData>
                          <DataTitle>{item?.name}</DataTitle>
                          {/* <Datatext>{item?.description} </Datatext> */}
                        </LeftSideData>
                        <RemoveButton role='button' onClick={() => handleOpenDeleteModal(item?.id)}>
                          Remove
                        </RemoveButton>
                      </Data>
                    );
                  })}
              </RepositoryData>
            </BottomContent>
          </Group>
        </Container>
      </AppLayout>
      <Modal maxWidth={'334px'} open={selectedModalId !== null} onClose={handleCloseDeleteModal}>
        <DeleteModal
          onOk={handleDeleteVercelAccount}
          modalTitle=' Remove Vercel Account'
          description=' Are you sure you want to remove this account?'
          onClose={handleCloseDeleteModal}
          loading={loading}
        />
      </Modal>
    </>
  );
}

export default observer(VercelIntegration);
